import { render, staticRenderFns } from "./vehiclechecks.html?vue&type=template&id=3f5f86f4&scoped=true&"
import script from "./vehiclechecks.vue?vue&type=script&lang=js&"
export * from "./vehiclechecks.vue?vue&type=script&lang=js&"
import style0 from "./vehiclechecks.vue?vue&type=style&index=0&id=3f5f86f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f86f4",
  null
  
)

export default component.exports